import request from '@/utils/request'
import { getToken } from '../utils/auth'
export function calldeicevideo (data) {
  return request({
    url: '/calldeicevideo',
    method: 'post',
    params: { token: getToken() },
    data
  })
}

export function receivedeicevideo (data) {
  return request({
    url: '/receivedeicevideo',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/zego.js